import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import {
  queryGetRespondedCount,
  queryGetTotalRespondedCount,
  queryGetRespondedCountLeaderboard,
} from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";
import {
  InlineWidgetWrapper,
  WidgetMember,
  WidgetMember2
} from "./components/Widget";
import Chart from "./components/Chart";
import InlineOrderedBox from "./components/InlineOrderedBox";
import ManagedTable from "./components/ManagedTable";
import Moment from 'moment'

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};
const Box = compose(
  graphql(queryGetRespondedCountLeaderboard, {
    ...gqlOptions,
    name: "leaderboard"
  }),
  graphql(queryGetTotalRespondedCount, { ...gqlOptions, name: "total" })
)(
  class RespondedCountPanel extends Component {
    getChart() {
      const {
        leaderboard: { loading, getRespondedCountLeaderboard }
      } = this.props;
      let series = [];
      if (!loading && getRespondedCountLeaderboard) {
        const blockSeries = getRespondedCountLeaderboard.data.reduce(
          (memo, dataPoint) => {
            let timestamp = dataPoint.name;
            dataPoint.details.forEach(agent => {
              let name = agent.name;
              let value = agent.value;
              if (!memo[name]) {
                memo[name] = [];
              }
              memo[name].push({
                name: timestamp,
                value: parseFloat(value.toFixed(2))
              });
            });
            return memo;
          },
          {}
        );
        for (let agentName in blockSeries) {
          series.push({
            name: agentName,
            data: blockSeries[agentName].sort((a, b) => {
              let tA = Moment(a.name).toDate().getTime()
              let tB = Moment(b.name).toDate().getTime()
              if(tA < tB) return -1
              else return 1
            })
          });
        }
      }
      let opt = {
        chartType: "line",
        title: "Responded Count",
        series
      };
      return <Chart {...opt} />;
    }

    getSummary() {
      const { leaderboard, total } = this.props;
      let highestBox = {
        title: "Highest",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      let lowestBox = {
        title: "Lowest",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      let averageBox = {
        title: "Total",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      if (!leaderboard.loading && leaderboard.getRespondedCountLeaderboard) {
        const normalizedAgentValue = leaderboard.getRespondedCountLeaderboard.data
          .reduce((memo, item) => {
            return memo.concat(item.details);
          }, [])
          .sort((a, b) => {
            if(a.value < b.value) {
              return -1
            } else return 1
          }).filter(item => item.value > 0)
        if (normalizedAgentValue.length >= 2) {
          const lowest = normalizedAgentValue[0];
          const highest = normalizedAgentValue[normalizedAgentValue.length - 1];
          highestBox.mainContent = highest.value.toFixed(0)
          highestBox.footer.text = "by "+highest.name;
          lowestBox.mainContent = lowest.value.toFixed(0)
          lowestBox.footer.text = "by "+lowest.name;
        } else if (normalizedAgentValue.length === 1) {
          const elem = normalizedAgentValue[0];
          highestBox.mainContent = elem.value.toFixed(0)
          highestBox.footer.text = "by "+elem.name;
          lowestBox.mainContent = elem.value.toFixed(0)
          lowestBox.footer.text = "by "+elem.name;
        }
      }
      if (!total.loading && total.getTotalRespondedCount) {
        if (total.getTotalRespondedCount.data[0]) {
          const elem = total.getTotalRespondedCount.data[0];
          averageBox.mainContent = elem.value.toFixed(0)
        }
      }
      const opt = {
        contentList: [lowestBox, highestBox, averageBox],
        size: "small"
      };
      return <InlineOrderedBox {...opt} />;
    }

    getTable() {
      const { leaderboard: { loading, getRespondedCountLeaderboard } } = this.props;
      let series = [
        {
          date: "",
          total: ""
        }
      ];
      if (!loading && getRespondedCountLeaderboard) {
        if (getRespondedCountLeaderboard.data.length > 0) {
          series = getRespondedCountLeaderboard.data.map(item => {
            let realCount = "-"
            if(item.value > 0) {
                realCount = item.value.toFixed(0)
            }

            const row = item.details.reduce((memo, item) => {
                return {...memo, [item.name]: item.value}
            }, {
                date: Moment(item.name).format("YYYY-MM-DD"),
                total: realCount, 
            })

            return row
          });
        }
      }
      
      const opt = {
        title: "Daily Responded Count",
        contentList: series
      };

      return <ManagedTable {...opt} />;
    }

    render() {
      const table = this.getTable();
      const chart = this.getChart();
      const summary = this.getSummary();
      return (
        <InlineWidgetWrapper>
          <WidgetMember>{chart}</WidgetMember>
          <WidgetMember2>
            {summary}
            {table}
          </WidgetMember2>
        </InlineWidgetWrapper>
      );
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/RespondedCountPanel.js